import { useState } from 'react';

import type { AuthError } from '@/features/auth/shared/types/auth';
import { useClerk } from '@clerk/react';

import { useCredentialsLogin } from './useCredentialsLogin';
import { useOAuthLogin } from './useOAuthLogin';

export const useLogin = () => {
  const [error, setError] = useState<AuthError | null>(null);
  const [loading, setLoading] = useState(false);
  const clerk = useClerk();

  const { handleSocialLogin, oauthLoading } = useOAuthLogin(setError);
  const { submitEmail, submitPassword } = useCredentialsLogin(setError, setLoading);

  return {
    loading: loading || oauthLoading,
    oauthLoading,
    error,
    isClerkLoading: !clerk.loaded,
    submitEmail,
    submitPassword,
    handleSocialLogin
  };
};
